import { parse } from "../utils";

export default {
  "get|NoLogin/GetFaqList": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: [
        {
          question: "Trynibusは何のサイトですか？",
          answer:
            "野村證券が提供する企業・業界分析業務に必要な全てを備える情報プラットフォームです。",
        },
        {
          question: "どんなコンテンツがありますか？",
          answer:
            "非上場企業を含む国内100万社以上、海外3万7千社の数値情報、定性情報、約550の業界レポートなど、企業・業界分析に必要なコンテンツを網羅しています。日経だから提供できる確かな情報で企業・業界分析を効率化します。",
        },
        {
          question: "どんな業務で利用できますか？",
          answer:
            "事業企画、経営企画、営業企画をはじめ、企業・業界分析に関わる様々なビジネスシーンで活用頂いています。",
        },
        {
          question: "どんな業務で利用できますか？",
          answer:
            "<p>インターネットにつながる環境があれば、どこからでもご利用頂けます。</p><h4>OS</h4><p>Microsoft Windows 10以降</p><h4>推奨ブラウザ</h4><p>・Microsoft Internet Explorer 11<br />・Firefox 通常版（最新版での動作を確認）<br />・Google Chrome（最新版での動作を確認）</p>",
        },
        {
          question: "Trynibusは何のサイトですか？",
          answer:
            "野村證券が提供する企業・業界分析業務に必要な全てを備える情報プラットフォームです。",
        },
        {
          question: "どんなコンテンツがありますか？",
          answer:
            "非上場企業を含む国内100万社以上、海外3万7千社の数値情報、定性情報、約550の業界レポートなど、企業・業界分析に必要なコンテンツを網羅しています。日経だから提供できる確かな情報で企業・業界分析を効率化します。",
        },
        {
          question: "どんな業務で利用できますか？",
          answer:
            "事業企画、経営企画、営業企画をはじめ、企業・業界分析に関わる様々なビジネスシーンで活用頂いています。",
        },
        {
          question: "どんな業務で利用できますか？",
          answer:
            "<p>インターネットにつながる環境があれば、どこからでもご利用頂けます。</p><h4>OS</h4><p>Microsoft Windows 10以降</p><h4>推奨ブラウザ</h4><p>・Microsoft Internet Explorer 11<br />・Firefox 通常版（最新版での動作を確認）<br />・Google Chrome（最新版での動作を確認）</p>",
        },
      ],
    };
  },
  "get|NoLogin/GetNewsReleaseList": (option) => {
    const pageSize = parseInt(parse("pageSize", option.url));
    let list = [
      {
        title: "Trynibus大幅アップデートのお知らせ",
        createDate: "2021-07-29T00:00:00",
        updateDate: null,
        category: "プレスリリース",
        libraryType: "page",
        linkUrl: "/announcements/detail",
        pdfFile: null,
      },
      {
        title: "新機能リリースのお知らせ",
        createDate: "2021-07-29T00:00:00",
        updateDate: "2020-04-17T09:12:08",
        category: "プレスリリース",
        libraryType: "page",
        linkUrl: "/announcements/detail",
        pdfFile: null,
      },
      {
        title: "Trynibus大幅アップデートのお知らせ",
        createDate: "2021-07-29T00:00:00",
        updateDate: "2020-04-18T09:12:08",
        category: "プレスリリース",
        libraryType: "pdf",
        pdfFile: require("@/assets/images/temp.pdf"),
        linkUrl: null,
      },
    ];
    if (pageSize === 10) {
      list = list.concat([
        {
          title: "Trynibus大幅アップデートのお知らせ",
          createDate: "2021-07-29T00:00:00",
          updateDate: "2020-04-16T09:12:08",
          category: "プレスリリース",
          libraryType: "page",
          linkUrl: "/announcements/detail",
          pdfFile: null,
        },
        {
          title: "新機能リリースのお知らせ",
          createDate: "2021-07-29T00:00:00",
          updateDate: "2020-04-17T09:12:08",
          category: "プレスリリース",
          libraryType: "page",
          linkUrl: "/announcements/detail",
          pdfFile: null,
        },
        {
          title: "Trynibus大幅アップデートのお知らせ",
          createDate: "2021-07-29T00:00:00",
          updateDate: "2020-04-18T09:12:08",
          category: "プレスリリース",
          libraryType: "pdf",
          pdfFile: require("@/assets/images/temp.pdf"),
          linkUrl: null,
        },
        {
          title: "Trynibus大幅アップデートのお知らせ",
          createDate: "2021-07-29T00:00:00",
          updateDate: "2020-04-16T09:12:08",
          category: "プレスリリース",
          libraryType: "page",
          linkUrl: "/announcements/detail",
          pdfFile: null,
        },
        {
          title: "新機能リリースのお知らせ",
          createDate: "2021-07-29T00:00:00",
          updateDate: "2020-04-16T09:12:08",
          category: "プレスリリース",
          libraryType: "page",
          linkUrl: "/announcements/detail",
          pdfFile: null,
        },
        {
          title: "Trynibus大幅アップデートのお知らせ",
          createDate: "2021-07-29T00:00:00",
          updateDate: "2020-04-16T09:12:08",
          category: "プレスリリース",
          libraryType: "pdf",
          pdfFile: require("@/assets/images/temp.pdf"),
          linkUrl: null,
        },
        {
          title: "Trynibus大幅アップデートのお知らせ",
          createDate: "2021-07-29T00:00:00",
          updateDate: "2020-04-16T09:12:08",
          category: "プレスリリース",
          libraryType: "pdf",
          pdfFile: require("@/assets/images/temp.pdf"),
          linkUrl: null,
        },
      ]);
    }
    return {
      code: 200,
      msg: "操作成功",
      data: {
        totalCount: list.length * 5,
        list,
      },
    };
  },
};
